var render = function render(){var _vm=this,_c=_vm._self._c;return _c('adv-input-spinner',{attrs:{"mini-cart":_vm.miniCart,"min":_vm.min,"max":_vm.max,"quantity":_vm.localQuantity,"button-css":_vm.buttonCss,"unavailable":!_vm.productCodeId},on:{"quantity-changed":_vm.quantityChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }